// extracted by mini-css-extract-plugin
export default {"pageError":"PageError--pageError--5jRvB"};